// extracted by mini-css-extract-plugin
export default {"wrap":"VideoPlay_wrap__Jt3fv","video":"VideoPlay_video__-mCOG"};